import { DataContract } from '@advsol/core';
import { formatDate } from '@angular/common';

/**
 * view model for the Declaration table that comes from a BO
 */
export class BODeclaration {

    ID: string;
    DECLARE: string;
    DECLARE_DATE: string;
    PartyId: string;
    
}
